import NavBar from "./navbar";
import Footer from "./footer";
import React from "react";
import { Outlet } from "react-router-dom";
import ScrollToTop from "../../utils/scrollToTop";
import { Box } from "@chakra-ui/react";

export const Layout = () => {
  //"#b4816b"
  return (
    <>
      <ScrollToTop />
      <NavBar />
      <Box pt={["70px", "70px", "108px", "108px"]}>
        <Outlet />
      </Box>

      <Footer />
    </>
  );
};
